import { render, staticRenderFns } from "./D3StackedBarChart.vue?vue&type=template&id=5ca91b14&scoped=true"
import script from "./D3StackedBarChart.vue?vue&type=script&lang=js"
export * from "./D3StackedBarChart.vue?vue&type=script&lang=js"
import style0 from "./D3StackedBarChart.vue?vue&type=style&index=0&id=5ca91b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca91b14",
  null
  
)

export default component.exports